// extracted by mini-css-extract-plugin
export var falconContainer = "_vf-2";
export var offerCenter = "_vf-0";
export var roktContainer = "_vf-1";